<template>
  <v-layout
    align-center
    align-content-center
    justify-center
    column
    style="margin-top: 200px"
  >
    <v-dialog
      v-model="forceLogOutDialog"
      persistent
      width="350"
      ref="forceLogOutDialog"
    >
      <v-card>
        <v-card-title class="headline logOutDialogHeadline">
          <v-icon color="#00558C" large>mdi-alert</v-icon>&nbsp;Authorization
          Revoked
        </v-card-title>

        <v-layout align-center justify-center>
          <hr width="90%" />
        </v-layout>

        <v-card-text
          >Your authorization to use this tool has been revoked and you have
          been logged out.</v-card-text
        >

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#319B42"
            dark
            class="menuBtn"
            @click="$router.push('/login')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <Authenticator></Authenticator> -->

    <v-icon color="green" size="100">mdi-account</v-icon>
    <h2 class="logInTitle">Log In To Your Account</h2>
    <v-card-subtitle v-if="waitFlag"
      >You are being logged in. Please wait...</v-card-subtitle
    >
    <br />

    <v-progress-circular
      indeterminate
      color="green"
      v-if="waitFlag"
      size="50"
    ></v-progress-circular>
    <v-btn color="green" dark class="menuBtn" v-if="!waitFlag" @click="signIn"
      >Log In With SecureAuth</v-btn
    >

    <!-- <v-btn disabled class="menuBtn" v-else>Log In With SecureAuth</v-btn> -->
    <br />
    <br />

    <modal
      name="errorModal"
      :draggable="true"
      :clickToClose="false"
      :height="200"
      :width="450"
    >
      <v-card style="height: 200px; width: 450px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Error</v-toolbar-title>
        </v-toolbar>
        <v-card-subtitle>
          Something went wrong. Please try again. If the error persists, please
          contact support.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#00558C"
            dark
            @click="
              $modal.hide('errorModal');
              $router.push('/logout');
            "
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="checkNameModal"
      :draggable="true"
      :clickToClose="false"
      :height="200"
      :width="450"
    >
      <v-card style="height: 200px; width: 450px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Authentication Error</v-toolbar-title>
        </v-toolbar>
        <v-card-subtitle>
          AMT could not authenticate you with the credentials entered. Please
          try logging in again and verify the case of your username.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('checkNameModal')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="unauthorizedModal"
      :draggable="true"
      :clickToClose="false"
      :height="200"
      :width="450"
    >
      <v-card style="height: 200px; width: 450px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Access Denied</v-toolbar-title>
        </v-toolbar>
        <v-card-subtitle>
          Your current role does not allow access to the Agency Maintenance
          Tool.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#00558C"
            dark
            @click="
              $modal.hide('unauthorizedModal');
              $router.push('/logout');
            "
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>
  </v-layout>
</template>
<script>
// import Authenticator from "aws-amplify-vue";
import { Auth, Hub } from "aws-amplify";
// import Authenticator from "@/components/authenticator/Authenticator.vue";
import EventBus from "@/eventBus.js";
import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "@/graphql/mutations";
import * as queries from "@/graphql/queries";
// import * as mutations from "@/graphql/mutations";
import recognizedRoles from "@/roles.js";
import utilityMixins from "@/utility-mixins.js";
import { HTTP } from "@/http-common.js";

export default {
  mixins: [utilityMixins],
  components: {
    // Authenticator
  },

  data() {
    return {
      waitFlag: false,
      forceLogOutDialog: false
    };
  },
  computed: {
    userPrimaryAgentNum() {
      let agentNum;

      if (this.isAgencyUser)
        agentNum = window.sessionStorage.getItem("primaryAgentNum");

      if (!this.isAgencyUser || !agentNum || agentNum == "null")
        agentNum = this.$store.state.currentUser.agentNum;

      return agentNum;
    }
  },
  created() {
    if (this.$route.query.checkname != "true") {
      if (this.$route.query.code && this.$route.query.code != "") {
        this.waitFlag = true;
      }
      if (this.$route.query.unauthorized) {
        this.forceLogOutDialog = true;
      }

      if (window.sessionStorage.getItem("jwt") != null) {
        this.$store.commit("setCurrentUser", null);
        window.sessionStorage.removeItem("currentUser");

        EventBus.$emit("setUserName", "");

        this.$store.commit("setUserRoles", null);
        window.sessionStorage.removeItem("primaryAgentNum");

        // this.$store.commit("setJWT", null);
        // window.sessionStorage.removeItem("jwt");

        this.$store.commit("setAccessCode", null);
        window.sessionStorage.removeItem("accessCode");

        this.$store.commit("setTmkClientId", null);
        window.sessionStorage.removeItem("tmkClientId");

        EventBus.$emit("setIsJWTAuthenticated", false);
      }
    }
  },
  methods: {
    signIn() {
      let currTime = new Date().getTime();
      this.$store.commit("setSignInTime", currTime);
      Auth.federatedSignIn();
    },
    async checkAccess(userRoles, userId) {
      console.log(userRoles);

      let roles = userRoles
        .replace(" ", "")
        .replace("[", "")
        .replace("]", "")
        .split(",");
      let validRoles = [];
      let rolesToStore = [];

      console.log(roles);

      if (roles != null && roles.length > 0) {
        for (let role of roles) {
          if (
            role.trim().startsWith(recognizedRoles.roles.CommonPrefix) ||
            role.trim() == recognizedRoles.roles.LNLAdmin
          ) {
            validRoles.push(role.trim());
          }
        }
      } else {
        return false;
      }

      if (!validRoles.length) {
        return false;
      }

      for (let role of validRoles) {
        if (role.trim() != recognizedRoles.roles.Agency && role.trim() != "") {
          rolesToStore.push(role.trim());
        }
      }

      console.log(validRoles);
      console.log(rolesToStore);

      if (validRoles.length == rolesToStore.length) {
        this.$store.commit("setUserRoles", rolesToStore.join(","));
        return true;
      }

      for (let role of validRoles) {
        if (role.trim() == recognizedRoles.roles.Agency) {
          // Agency user
          // determine if they can access based on place in hierarchy:

          try {
            let results = await API.graphql(
              graphqlOperation(queries.getUserByAgentNum, {
                agentNum: userId,
                company: this.$store.state.currentCompany
              })
            ).catch(e => {
              this.addToErrorLogs("LogIn checkAccess getUserByAgentNum", e);
              this.$modal.show("errorModal");
              return false;
            });

            if (results && results.data.getUserByAgentNum.RoleAbbr) {
              let HierRole = results.data.getUserByAgentNum.RoleAbbr;

              if (HierRole == "AO" || HierRole == "AA") {
                rolesToStore.push(role.trim());
              }
            }

            if (results && results.data.getUserByAgentNum.AgentNumPrimary) {
              window.sessionStorage.setItem(
                "primaryAgentNum",
                results.data.getUserByAgentNum.AgentNumPrimary
              );

              let user = this.$store.state.currentUser;

              if (user) {
                user.agentNum = results.data.getUserByAgentNum.AgentNumPrimary;
                this.$store.commit("setCurrentUser", user);
                window.sessionStorage.setItem("currentUser", user);
                EventBus.$emit("setUserName", user.name);
              }
            }

            if (rolesToStore.length == 0) {
              return false;
            } else {
              this.$store.commit("setUserRoles", rolesToStore.join(","));
              return true;
            }
          } catch (e) {
            this.addToErrorLogs("Login.vue checkAccess", e);
            this.$modal.show("errorModal");
            return false;
          }
        }
      }
    }
  },
  mounted() {
    try {
      if (this.$route.query.checkname == "true") {
        this.$modal.show("checkNameModal");
      }

      if (this.$route.query.code && this.$route.query.code != "") {
        this.waitFlag = true;
      }

      EventBus.$on(
        "authenticated",
        function() {
          EventBus.$emit("setIsAuthenticated", true);
          if (this.$route.path != "/") this.$router.push("/");
        }.bind(this)
      );

      Hub.listen("auth", async ({ payload: { event } }) => {
        if (event.indexOf("failure") >= 0) {
          console.log("Authentication failure.");
          console.log(event);
          this.addToErrorLogs("LogIn.vue mounted Hub.listen auth", event);
          // this.$store.commit("setUser", null);
          this.$store.commit("setCurrentUser", null);
          window.sessionStorage.removeItem("currentUser");
          EventBus.$emit("setUserName", null);
          this.$store.commit("setUserRoles", "");
          this.waitFlag = false;
          EventBus.$emit("setIsAuthenticated", false);
          //this.$modal.show("errorModal");
          return;
        }

        switch (event) {
          case "signIn":
            this.waitFlag = true;

            await this.$Amplify.Auth.currentAuthenticatedUser()
              .then(async user => {
                try {
                  if (user == undefined) {
                    this.isAuthenticated = false;
                    this.waitFlag = false;
                  } else {
                    // this.$store.commit("setUser", user);
                    let identities = JSON.parse(user.attributes.identities);
                    let identity = identities[0];

                    if (identity) {
                      this.$store.commit("setCurrentUser", {
                        agentNum: identity.userId,
                        name: (
                          (user.attributes.given_name
                            ? user.attributes.given_name
                            : "") +
                          " " +
                          (user.attributes.family_name
                            ? user.attributes.family_name
                            : "")
                        ).trim()
                      });

                      window.sessionStorage.setItem(
                        "currentUser",
                        JSON.stringify({
                          agentNum: identity.userId,
                          name: (
                            (user.attributes.given_name
                              ? user.attributes.given_name
                              : "") +
                            " " +
                            (user.attributes.family_name
                              ? user.attributes.family_name
                              : "")
                          ).trim()
                        })
                      );

                      EventBus.$emit(
                        "setUserName",
                        (
                          (user.attributes.given_name
                            ? user.attributes.given_name
                            : "") +
                          " " +
                          (user.attributes.family_name
                            ? user.attributes.family_name
                            : "")
                        ).trim()
                      );
                    }

                    if (
                      !user.attributes.zoneinfo ||
                      !user.attributes.zoneinfo.length
                    ) {
                      // this.$store.commit("setUser", null);
                      this.$store.commit("setCurrentUser", null);
                      window.sessionStorage.removeItem("currentUser");
                      EventBus.$emit("setUserName", null);
                      this.$store.commit("setUserRoles", "");
                      this.waitFlag = false;
                      EventBus.$emit("setIsAuthenticated", false);
                      window.sessionStorage.removeItem("primaryAgentNum");
                      this.$modal.show("unauthorizedModal");
                      return;
                    }

                    try {
                      let OK;

                      OK = await this.checkAccess(
                        user.attributes.zoneinfo,
                        identity.userId
                      );

                      if (OK) {
                        this.isAuthenticated = true;
                        this.waitFlag = false;

                        if (
                          this.userPrimaryAgentNum != null &&
                          this.userPrimaryAgentNum != undefined
                        ) {
                          HTTP.post(
                            "bulkunlock",
                            {
                              editedByNum: this.userPrimaryAgentNum
                            },
                            {
                              headers: {
                                "Content-Type": "application/json"
                              }
                            }
                          )
                            .then(results => {
                              let retHiers = results.data;

                              if (retHiers && retHiers.length) {
                                for (let retHier of retHiers) {
                                  this.$store.commit(
                                    "setBroadcastUnlock",
                                    true
                                  );
                                  this.$store.commit(
                                    "setUnlockedHier",
                                    retHier.AO
                                  );

                                  API.graphql(
                                    graphqlOperation(
                                      mutations.broadcastUnlock,
                                      {
                                        input: {
                                          AOAgentNum: retHier.AO,
                                          Msg: "The hierarchy is now unlocked.",
                                          Editing: false,
                                          From: this.$store.state.currentUser
                                            .agentNum,
                                          FromName: "AMT",
                                          To: "AMT USER",
                                          FromSession: this.$store.state
                                            .session,
                                          ToSession: retHier.Session
                                        }
                                      }
                                    )
                                  ).catch(e => {
                                    this.addToErrorLogs(
                                      "App.vue sendReplyMsg broadcastUnlock",
                                      e
                                    );
                                    this.overlay = false;
                                    this.$modal.show("errorModal");
                                    return;
                                  });
                                }
                              }
                            })
                            .catch(e => {
                              this.addToErrorLogs(
                                "logout mounted POST /bulkunlock",
                                e
                              );
                            });
                        }

                        if (this.$route.path != "/") {
                          this.$router.push("/");
                        }
                        EventBus.$emit("setIsAuthenticated", true);
                      } else {
                        // this.$store.commit("setUser", null);
                        this.$store.commit("setCurrentUser", null);
                        window.sessionStorage.removeItem("currentUser");
                        EventBus.$emit("setUserName", null);
                        this.$store.commit("setUserRoles", "");
                        this.waitFlag = false;
                        EventBus.$emit("setIsAuthenticated", false);
                        window.sessionStorage.removeItem("primaryAgentNum");
                        this.$modal.show("unauthorizedModal");
                        return;
                      }
                    } catch (e) {
                      this.addToErrorLogs("LogIn.vue mounted Hub.listen", e);

                      // this.$store.commit("setUser", null);
                      this.$store.commit("setCurrentUser", null);
                      window.sessionStorage.removeItem("currentUser");
                      EventBus.$emit("setUserName", null);
                      this.$store.commit("setUserRoles", "");
                      this.waitFlag = false;
                      EventBus.$emit("setIsAuthenticated", false);
                      this.$modal.show("errorModal");
                    }
                  }
                } catch (e) {
                  this.addToErrorLogs("LogIn.vue mounted Hub.listen", e);

                  // this.$store.commit("setUser", null);
                  this.$store.commit("setCurrentUser", null);
                  window.sessionStorage.removeItem("currentUser");
                  EventBus.$emit("setUserName", null);
                  this.$store.commit("setUserRoles", "");
                  this.waitFlag = false;
                  EventBus.$emit("setIsAuthenticated", false);
                  this.$modal.show("errorModal");
                }
              })
              .catch(e => {
                this.addToErrorLogs("LogIn.vue mounted Hub.listen", e);
                // this.$store.commit("setUser", null);
                this.$store.commit("setCurrentUser", null);
                window.sessionStorage.removeItem("currentUser");
                EventBus.$emit("setUserName", null);
                this.$store.commit("setUserRoles", "");
                this.waitFlag = false;
                EventBus.$emit("setIsAuthenticated", false);
                this.$modal.show("errorModal");
              });

            break;
          case "signOut":
            break;
          case "customOAuthState":
            break;
        }
      });
    } catch (e) {
      this.addToErrorLogs("Login.vue mounted", e);
      this.waitFlag = false;
      this.$modal.show("errorModal");
    }
  },
  beforeDestroy() {
    EventBus.$off("authenticated");
  }
};
</script>
<style scoped>
.waitCircle {
  z-index: 1000;
  position: absolute;
  top: 80%;
  left: 50%;
}
</style>
